<template>
  <v-app id="Gbmt1">
    <v-main>
      <v-container fluid>    
        <v-card flat>
          <v-card-title class="justify-center">"Paid" overview (EUR)</v-card-title>
          <v-divider class="mb-2"/>
          <v-simple-table dense v-if="hobos.length > 0 && !loading">
            <thead>
              <tr>
                <th style="text-align: right; padding-right: 30px;">Count</th>
                <th style="width: 10vw">Booking</th>
                <th style="width: 18vw">Created</th>
                <th style="width: 18vw">Last update</th>
                <th style="width: 18vw">Method</th>
                <th style="width: 18vw">Transaction Id</th>
                <th style="text-align: right; padding-right: 30px;">Amount</th>
              </tr>
            </thead>
            <tbody v-for="(hobo, i) in hobos" :key="i">
              <tr :class="{'color': i%2!==0}" style="cursor: default">
                <td align="right" style="width: 80px; padding-right: 30px;">{{ i+1 }}</td>
                <td style="color: blue; cursor: pointer;" @click="$router.open('/huov/onHuov/' + hobo.huov_encrid)">{{ hobo.huov_code }}</td>
                <td>{{ formatDateTime(hobo.inv_dt) }}</td>
                <td>{{ formatDateTime(hobo.updated_dt) }}</td>
                <td>{{ hobo.methode_oms }}</td>
                <td>{{ hobo.transaction_id }}</td>
                <td align="right" style="padding-right: 30px;">{{ formatAmount(hobo.bedrag) }}</td>
              </tr>
            </tbody>  
          </v-simple-table>  
          <div v-else class="mt-10" style="display:flex; flex-direction: row; justify-content: center;">No data found</div>
        </v-card>  
      </v-container>
    </v-main>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>

import navBar from "@/components/ui/navbars/navbar.vue";

export default {
  components: {
    navBar,
  },
  data() {
    return {
      loading: false,
      hobos: []
    }
  },
mounted() {
  this.getData();
},
methods: {
  formatAmount(amount) {
    let xamount = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount).replace('€', '');
    if(amount === 0) {
      return '';
    } else return xamount;
  },
  formatDateTime(date) {
    if (!date) return '';
    return this.$moment(date).format('DD-MM-YYYY HH:mm:ss');
  },
  getData() {
      this.loading = true;
      this.$axios
      .post("ares/json/ares/task/fin/paynl/getHoboPaid.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getHoboPaid"
        }
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
          this.loading = false;
        } else {
          this.hobos = res.data.getHoboPaid;
          this.loading = false;
        }
      })
  },
}
};

</script>

<style scoped>
.color {
    background-color: #faf8f8;
}
</style>